import { oc } from "@orpc/contract";
import { z } from "zod";

const controlPlaneLinkSchema = z.object({
  instanceId: z.uuid(),
  tenantId: z.uuid(),
  name: z.string(),
  appUrl: z.string().url(),
  apiUrl: z.string().url(),
  environment: z.string(),
});

const controlPlaneStatusSchema = z.object({
  linked: z.boolean(),
  connected: z.boolean(),
  lastHeartbeatAt: z.string().nullable(),
  lastError: z.string().nullable(),
});

export const controlPlaneOrgContracts = {
  claimEnrollment: oc
    .input(
      z.object({
        token: z.string().min(1),
      }),
    )
    .output(controlPlaneLinkSchema)
    .route({
      method: "POST",
      summary:
        "Claim a control-plane enrollment token for the current organization",
    }),

  getStatus: oc.input(z.void()).output(controlPlaneStatusSchema).route({
    method: "POST",
    summary: "Get the current control-plane connection status",
  }),
};

export type ControlPlaneOrgLink = z.infer<typeof controlPlaneLinkSchema>;
export type ControlPlaneStatus = z.infer<typeof controlPlaneStatusSchema>;
